import { arrayRandomSort } from '@flatbiz/utils';
import { KeyboardKeyItem } from './types';

export const getKeyboardKeyList = (param: {
  randomOrder?: boolean;
  customKey?: string | null;
  showOkButton?: boolean;
}) => {
  let numberKeys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'] as KeyboardKeyItem[];
  if (param.randomOrder) {
    numberKeys = arrayRandomSort(numberKeys);
  }
  const customKey = param.customKey || '';
  const number9Keys =
    typeof numberKeys[9] === 'string' ? { key: numberKeys[9], name: numberKeys[9] } : numberKeys[9];
  if (param.showOkButton) {
    return numberKeys
      .slice(0, 3)
      .concat({ key: 'back', name: '' })
      .concat(numberKeys.slice(3, 6))
      .concat({ key: 'ok', name: '确定', ySpan: 3 })
      .concat(numberKeys.slice(6, 9))
      .concat({ key: number9Keys.key, name: number9Keys.name, xSpan: 2 })
      .concat({ key: customKey ? 'custom' : 'empty-custom', name: customKey });
  }
  return numberKeys
    .slice(0, 9)
    .concat({ key: customKey ? 'custom' : 'empty-custom', name: customKey })
    .concat({ key: number9Keys.key, name: number9Keys.name })
    .concat({ key: 'back', name: '' });
};
